const ANY_RESOURCE_ID = '*'
const ANY_INTERNAL_RESOURCE_ID = '*internal'
const ANY_EXTERNAL_RESOURCE_ID = '*external'

export { ANY_RESOURCE_ID, ANY_INTERNAL_RESOURCE_ID, ANY_EXTERNAL_RESOURCE_ID }
